import React from 'react';
import { BRAND } from '../../lib/brand';

// A few abstract shimmer rows that stand in for content cards.
export function SkeletonCards({ count = 3 }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => i + 1).map(n => (
        <div key={n} style={{ background: 'white', borderRadius: '12px', marginBottom: '0.75rem', boxShadow: 'var(--shadow-sm)', padding: '1rem', opacity: 1 - n * 0.15 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div className="skeleton-bone" style={{ width: 28, height: 28, borderRadius: '50%', flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div className="skeleton-bone" style={{ height: 16, width: `${70 - n * 10}%`, marginBottom: 8 }} />
              <div className="skeleton-bone" style={{ height: 11, width: '45%' }} />
            </div>
            <div className="skeleton-bone" style={{ width: 24, height: 24, borderRadius: '50%' }} />
          </div>
        </div>
      ))}
    </>
  );
}

// Quiet, role-agnostic splash for the auth/profile wait and the role chunk
// download. Deliberately holds nothing but the mark: at this point we may not
// even have a signed-in user, so a client-facing bone-health tip and a fake
// dashboard of shimmer cards were being shown to whoever opened the login page
// and to the therapist on her way to her own dashboard. The tip belongs on the
// client's own skeleton, where their data is what's being waited on.
export default function BrandedLoader({ firstName }) {
  return (
    <div style={{
      minHeight: '100vh', background: 'var(--off-white)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: '1.25rem', padding: '1rem',
    }}>
      <img src={BRAND.logo} alt="" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover', boxShadow: 'var(--shadow-md)' }} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontFamily: 'var(--font-serif)', fontSize: '1.35rem', color: 'var(--navy)', fontWeight: 500 }}>{BRAND.name}</div>
        {firstName && <div style={{ fontSize: '0.85rem', color: 'var(--charcoal)', opacity: 0.6, marginTop: '0.2rem' }}>Hi {firstName}</div>}
      </div>
      <div className="spinner" aria-label="Loading" role="status" />
    </div>
  );
}
